import React from 'react';
import { Shield, AlertTriangle, Lock, Eye } from 'lucide-react';
import { Card } from '../ui/Card';

export const SecurityNotice: React.FC = () => {
  return (
    <Card variant="red" className="mb-6">
      <div className="flex items-start space-x-3">
        <Shield className="h-6 w-6 text-red-500 flex-shrink-0 mt-1" />
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Security & Compliance Notice</h3>
          
          <div className="space-y-4 text-sm text-gray-700">
            <div className="flex items-start space-x-2">
              <AlertTriangle className="h-4 w-4 text-amber-500 flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-amber-800">Authorized Use Only</p>
                <p>This platform is designed for authorized security testing and research purposes. Users must ensure compliance with applicable laws and regulations.</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-2">
              <Lock className="h-4 w-4 text-blue-500 flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-blue-800">Data Security</p>
                <p>API keys and sensitive data are processed securely. However, users should follow their organization's security policies when testing external AI services.</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-2">
              <Eye className="h-4 w-4 text-purple-500 flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-medium text-purple-800">Monitoring & Logging</p>
                <p>All security assessments are logged for audit purposes. Ensure you have proper authorization before testing any AI systems.</p>
              </div>
            </div>
          </div>
          
          <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="text-xs text-red-800">
              <strong>Disclaimer:</strong> Users are solely responsible for ensuring their use of this platform complies with all applicable laws, regulations, and terms of service of target AI systems.
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};